// extracted by mini-css-extract-plugin
export default {"root":"HighlightClipScrollerControls_root__s+vck","tooltip":"HighlightClipScrollerControls_tooltip__Q0Fsj","next":"HighlightClipScrollerControls_next__hPYj4"};